import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import { UPDATE_PIN_IN_LIST } from '../plan-viewer/constants'
import * as actionTypes from './constants'
import { sortPins } from '../../utils/sortManager'

const initialState = fromJS({
  sort: 'Title', // [Created, Title, Category, Plan, State]
  sortDirection: 'DESC', // [ASC, DESC]
  search: '',
  quickFilter: 'Any', // [Any, ByMe, ByOthers]
  stateFilter: 'Active', // [Active, Inactive, All]
  page: 0,
  size: 25
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_GROUP_CONTENT:
      return state
        .set('gettingGroupContent', false)
        .delete('getGroupContentError')
        .delete('groupContent')

    case actionTypes.GET_GROUP_CONTENT:
      return state
        .set('gettingGroupContent', true)
        .delete('getGroupContentError')
    case actionTypes.GET_GROUP_CONTENT_DONE:
      return state
        .setIn(['groupContent', action.page], fromJS(action.content))
        .set('gettingGroupContent', false)
    case actionTypes.GET_GROUP_CONTENT_ERROR:
      return state
        .set('getGroupContentError', action.error)
        .set('gettingGroupContent', false)

    case actionTypes.REMOVE_PINS:
      return state.set('removingPinsBatch', true)
    case actionTypes.REMOVE_PINS_DONE: {
      const page = state.get('page')
      const groupContent = state.get('groupContent').get(page)
      const content = groupContent
        .get('content')
        .filter((groupPin) => action.pins.indexOf(groupPin.get('id')) < 0)
      return state
        .set('removingPinsBatch', false)
        .setIn(['groupContent', page], groupContent.set('content', content))
    }
    case actionTypes.REMOVE_PINS_ERROR:
      return state
        .set('removePinsBatchError', action.error)
        .set('removingPinsBatch', false)

    // add pins to group
    case actionTypes.ADD_PINS_TO_GROUP:
      return state.set('addingPinsToGroup', true).delete('addPinsToGroupError')
    case actionTypes.ADD_PINS_TO_GROUP_DONE:
      return state.set('addingPinsToGroup', false)
    case actionTypes.ADD_PINS_TO_GROUP_ERROR:
      return state
        .set('addPinsToGroupError', action.error)
        .set('addingPinsToGroup', false)

    case actionTypes.SET_GROUP_CONTENT_PARAMS:
      return state.merge(action.params)

    case UPDATE_PIN_IN_LIST: {
      let newState = state

      if (state.get('groupContent')) {
        // delete old one and insert new one on the rigth sorted place
        const sortProjectPinsFunc = sortPins(
          state.get('sort'),
          state.get('sortDirection')
        )
        let saved = false
        let deleted = false
        let lastPage = 0

        state.get('groupContent').forEach((pageContent, page) => {
          lastPage = page

          const pContent = pageContent

          pageContent.get('content').forEach((p, key) => {
            const pin = fromJS(p)

            let pinIndex = key
            if (!saved && deleted) {
              pinIndex -= 1
            } else if (saved && !deleted) {
              pinIndex += 1
            }

            if (!saved) {
              const updatedPinMap = fromJS(action.pin)
              const pinCompared = sortProjectPinsFunc(updatedPinMap, pin)
              if (pinCompared === -1) {
                if (pin.get('id') !== action.pin.id) {
                  newState = newState.setIn(
                    ['groupContent', page, 'content'],
                    pContent.get('content').insert(pinIndex, updatedPinMap)
                  )
                } else {
                  newState = newState.setIn(
                    ['groupContent', page, 'content', pinIndex],
                    updatedPinMap
                  )
                  deleted = true
                }
                saved = true
              } else if (pinCompared === 0) {
                if (pin.get('id') === action.pin.id) {
                  newState = newState.setIn(
                    ['groupContent', page, 'content', pinIndex],
                    updatedPinMap
                  )
                  deleted = true
                  saved = true
                }
              } else if (pin.get('id') === action.pin.id) {
                newState = newState.deleteIn([
                  'groupContent',
                  page,
                  'content',
                  pinIndex
                ])
                deleted = true
              }
            } else if (!deleted && pin.get('id') === action.pin.id) {
              newState = newState.deleteIn([
                'groupContent',
                page,
                'content',
                pinIndex
              ])
              deleted = true
            }
          })
        })

        if (!saved && newState.get('groupContent').get(lastPage)) {
          newState = newState.setIn(
            ['groupContent', lastPage, 'content'],
            newState
              .getIn(['groupContent', lastPage, 'content'])
              .push(fromJS(action.pin))
          )
        }
      }

      return newState
    }

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
